/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { MdArrowBack } from 'react-icons/md';

import logo from '../../assets/images/logo.png';
import history from '~/services/history';
import { Container, Icon } from './styles';
import api from '~/services/api';

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [sendingMail, setSendingMail] = useState(false);

  const handleInputChange = (e) => {
    const { value } = e.target;
    setEmail(value);
  };

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      if (email) {
        setSendingMail(true);
        await api.post('passwords', {
          email,
          redirect_url:
            'https://app.apollopartners.com.br/forgotpassword/reset',
        });
        setSendingMail(false);
        return toast.success('E-mail de recuperaçāo de senha enviado.');
      }
      return toast.error('Preencha o seu e-mail e tente novamente.');
    } catch (error) {
      setSendingMail(false);
      return toast.error('E-mail nāo cadastrado, tente novamente.');
    }
  }

  return (
    <>
      <Icon onClick={() => history.push('/')}>
        <MdArrowBack size={50} color="#36ded6" />
      </Icon>
      <Container>
        <img src={logo} alt="Apollo" />

        <form>
          <input
            type="email"
            placeholder="E-mail"
            onChange={handleInputChange}
          />

          <button type="submit" onClick={(e) => handleSubmit(e)}>
            {sendingMail === true ? (
              <p>ENVIANDO E-MAIL...</p>
            ) : (
              <p>RESETAR SENHA</p>
            )}
          </button>
        </form>
      </Container>
    </>
  );
}
